import { Component, OnDestroy, OnInit } from '@angular/core';
import { isBeta } from '../shared/services';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ControllerService } from '../shared/services/controller.service';


/**
 * /expand component
 */

declare var $: any;

@Component({
    selector: 'app-question',
    templateUrl: './question.component.html',
    styleUrls: ['./question.component.scss'],
    standalone: false
})
export class QuestionComponent implements OnInit, OnDestroy {
  questions: any = [];
  question: {title:string, body: string} = null;
  maxCount = 0;
  carousel: any;
  currentIndex = 0;
  courseProgress: number = 0;

  qpListener = null

  title:string = ''

  expanded: boolean = false

  pages = []

  page = -1

  components = []

  showNext: boolean = false
  showBack: boolean = false
  alwaysShowBack: boolean = false

  showSkip: boolean = isBeta()

  constructor(private route: ActivatedRoute, public controller: ControllerService) { }

  loadQuestion( expanded = false ) {
    const stepItem = this.controller.getStepItem()

    window.scrollTo(0,0)

    this.expanded = expanded


    this.currentIndex = stepItem.index


    this.title = stepItem.component.elements.find( ({type}) => type == 'header').value

    this.pages = stepItem.component.subComponents

    this.page = this.controller.getPage()

    if (this.pages.length > 1) {
      this.showNext = false
    }else{
      this.showNext = true
    }

    this.showBack = false

    this.alwaysShowBack = stepItem.component.properties && stepItem.component.properties.showBack == 'true' ? true : false

  }

  ngOnInit() {


    this.components = this.controller.getSectionComponents()




    this.qpListener = this.route.queryParams
    .subscribe( params => {


      this.currentIndex = params.id

      this.maxCount = this.questions.length;

      this.loadQuestion(this.expanded);
    })


    this.updateBackground();


  }

  ngOnDestroy(): void {
    this.qpListener.unsubscribe()
  }

  onIveSeenEverything() {
    this.showNext = true
    this.showBack = this.alwaysShowBack || this.currentIndex > 0
  }

  onExpand(){
    this.expanded = true

    this.showBack = this.alwaysShowBack
  }

  async onBack() {

    this.expanded = false
    await this.controller.backComponent()
  }

  async onNext() {
    this.expanded = false

    await this.controller.next()

  }

  updateBackground() {
    $('body').removeClass();
    $('body').addClass('full-screen-bg-image welcome_1');
  }

}
